import './popupModel.css'
;import ReactDOM from "react-dom";

const Popup = ({children, showPopup, classes}) => {
    return(
        <div className={`popup ${classes}`}>
            {/*<div onClick={e => showPopup(false)} className="x"></div>*/}
            {children}
        </div>
    )
}

const Backdrop = ({showPopupBackDrop}) => {
    return(
        <div onClick={e => showPopupBackDrop(false)} className={'backdrop'}></div>
    )
}

const popupPlaceHolder = document.getElementById('popup-model-holder');

const PopupModel = ({children, showPopupModel, classes}) => {
    return(
        <>
            {ReactDOM.createPortal(<Backdrop showPopupBackDrop={showPopupModel}></Backdrop>, popupPlaceHolder)}
            {ReactDOM.createPortal(<Popup showPopup={showPopupModel} classes={classes}>{children}</Popup>, popupPlaceHolder)}
        </>
    )
}

export default PopupModel;
